module.exports = __webpack_public_path__ + "img/canyutitle.7cbec871.png";